<!-- Period, only when the Driver is Site -->
<div class="forecast-table-grid-select-container">
  <ng-select
    class="forecast-table-grid-select"
    [searchable]="false"
    [clearable]="false"
    [appendTo]="'body'"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [auxTooltip]="tooltip"
    [ngClass]="{ 'is-invalid': isInvalid }"
    [ngModel]="selectedPeriodSiteOption"
    (ngModelChange)="onModelChange($event)"
  >
    @for (option of periodSiteOptions; track option) {
      <ng-option [value]="option.value">
        <span [title]="option.label">{{ option.label }}</span>
      </ng-option>
    }
  </ng-select>
</div>
